export { default } from './Badge';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Badge/index.js
// module id = 306
// module chunks = 0